import { ExportOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'
import { dowloaderUtils } from '../../utils/dowloader.utils'

const ExportTimeKeepingToExcel = props => {
  const { timekeepingStore, params } = props

  const [exportLoading, setExportLoading] = useState(false)

  const openExport = async () => {
    setExportLoading(true)
    timekeepingStore
      .exportToExcel(params)
      .then(response => {
        const { fromDate, toDate, keyword } = params
        let deName = ''

        dowloaderUtils.dowloadFileFromResponse(response.data, {
          filename: `${deName}${
            keyword ? `${keyword} c` : 'C'
          }hấm công ${fromDate} - ${toDate}.xlsx`,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  return (
    <>
      <Button
        icon={<ExportOutlined />}
        loading={exportLoading}
        onClick={openExport}>
        Xuất dữ liệu tổng
      </Button>
    </>
  )
}

ExportTimeKeepingToExcel.propTypes = {}

export default inject('timekeepingStore')(observer(ExportTimeKeepingToExcel))
